<template>
  <el-dialog :visible.sync="dg" @closed="closed" append-to-body class="sys-message-content" title="消息详情">
    <div class="sys-message-dg">
      <div>
        <span class="title">公告标题</span>
        <span>{{ curItem.title }}</span>
      </div>
      <div>
        <span class="title">公告内容</span>
        <span class="content" v-html="curItem.content"></span>
      </div>
      <div>
        <span class="title">提醒方式</span>
        <span>{{ curItem.is_notify_popup_label }}</span>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { Dialog } from 'element-ui';

export default {
  name: 'SysMessage',
  components: { ElDialog: Dialog },
  props: {
    curItem: {
      required: true,
      type: Object,
      default: () => ({})
    },
    visible: {
      required: true,
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    visible() {
      this.dg = this.visible;
    }
  },
  data() {
    return {
      dg: false
    };
  },
  methods: {
    closed() {
      this.$emit('update:visible', false);
    }
  }
};
</script>
<style lang="less">
.sys-message-dg {
  > div {
    display: flex;
    margin: 15px 0;
    .title {
      width: 120px;
      font-weight: 700;
    }
  }
  .content {
    padding: 0 10px;
    border-radius: 3px;
    width: 100%;
    background: #fafafa;
    margin-left: 20px;
  }
}
.sys-message-content .el-dialog__body {
  padding-top: 0;
}
</style>
